import React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import Image from '@common-components/image/Image';
import { configs } from '@constants/configs/configs';

const PageWrapper = styled.main`
    min-height: calc(100vh - 380px);
    display: flex;
    align-items: center;
    justify-content: center;
`;

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 3rem 1.5rem;
    width: 100%;
    margin: 0 auto;
`;

const Illustration = styled.div`
    margin-bottom: 1.5rem;

    img {
        max-width: 200px;
        height: auto;
    }
`;

const Title = styled.h1`
    margin-top: 2.4rem;
    margin-bottom: 1.6rem;
    font-size: 3.2rem;
    line-height: 125%;
    font-weight: 500;
`;

const Description = styled.p`
    margin-top: 0;
    margin-bottom: 1rem;
    color: ${({ theme }) => theme.gray3};
    font-weight: 400;
    line-height: 160%;
`;

function HistoricalIncorrectReferenceIdPage() {
    const errorImage = configs.ENV.DEVELOPMENT
        ? '/assets/images/nm-computer-troubleshooting.png'
        : configs.endpoints.IMAGES.processReplacements({
            relativePath: '/resources/img',
            fileName: 'nm-computer-troubleshooting.png',
        });

    return (
        <PageWrapper id="gi-historical-not-found" data-testid="historical-reference-id-not-found-page">
            <Container
                role="alert"
                aria-live="assertive"
                data-testid="historical-reference-id-not-found-container"
            >
                <Illustration data-testid="historical-reference-id-not-found-illustration">
                    <Image
                        source={errorImage}
                        desc="historical.consumer.referenceId.notFound.img.desc"
                        name="incorrect_reference_id_img"
                    />
                </Illustration>
                <Title id="incorrect-reference-id-heading" data-testid="historical-reference-id-not-found-title">
                    <FormattedMessage id="historical.consumer.referenceId.notFound.title" />
                </Title>
                <Description data-testid="historical-reference-id-not-found-description">
                    <FormattedMessage id="historical.consumer.referenceId.notFound.description" />
                </Description>
                <Description data-testid="historical-reference-id-not-found-helptext">
                    <FormattedMessage id="historical.consumer.referenceId.notFound.helpText" />
                </Description>
            </Container>
        </PageWrapper>
    );
}

export default HistoricalIncorrectReferenceIdPage;
